import en from "../locales/en.json";
import sw from "../locales/sw.json";
import { SET_LANGUAGE } from "../actions/Types";

const initialState = {
  language: "en",
  translations: en
};

const LanguageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
        translations: action.payload === "en" ? en : sw
      };
    default:
      return state;
  }
};

export default LanguageReducer;
